import React, { useState } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { FormInput } from 'components/form/FormInput';
import './DealModalEditTitle.scss';
/**
 * @component DealModalEditTitle
 * @since 1.0.0
 * @hidden
 */
export function DealModalEditTitle(props) {
    const { onClose } = props;
    const { deal, updateDealField } = useDealConfiguratorContext();
    const [title, setTitle] = useState((deal === null || deal === void 0 ? void 0 : deal.title) || '');
    const footerActions = (React.createElement("div", { className: "deal-modal-edit-title-container-footer" },
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement(Button, { style: "primary", label: t('Update'), onPress: () => {
                updateDealField('title', title, 'string');
                onClose();
            } })));
    return (React.createElement("div", { className: "deal-modal-edit-title" },
        React.createElement(Modal, { title: t('Edit title'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-modal-edit-title-content" },
                React.createElement(FormInput, { label: t('Title'), value: title, onChange: (value) => setTitle(value), placeholder: t('Enter title') })))));
}
